import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendar3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCalendar3"><Path d="M3.5 4.5H20.5V20.5H3.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 8.5H16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCalendar3;
